import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from "react";
import { useInView } from "react-intersection-observer";
export const RefsContext = React.createContext({
    hardfactsRef: null,
    locationRef: null,
    contactCardRef: null,
    newBuildRef: null,
    priceRef: null,
    descriptionRef: null,
    sponsorRef: null,
    featuresRef: null,
    PartnerBoxCommercialRef: null,
    locationDescriptionRef: null,
    additionalDescriptionRef: null,
    energyRef: null,
    sellerLeadTeaserRef: null,
    richMediasRef: null,
    mortgageSectionRef: null,
    priceComparisonRef: null,
    documentsRef: null,
    PartnerBoxServicesRef: null,
    propertyProviderRef: null,
    classifiedKeysRef: null,
    mobilePreview: {
        ref: () => null,
        inView: false,
    },
    geoRisksRef: null,
});
export const RefsProvider = ({ children }) => {
    const [mobilePreviewRef, inViewMobilePreview] = useInView({
        threshold: 0.1,
        delay: 500,
        initialInView: true,
    });
    const refs = {
        propertyProviderRef: useRef(null),
        mortgageSectionRef: useRef(null),
        hardfactsRef: useRef(null),
        locationRef: useRef(null),
        contactCardRef: useRef(null),
        newBuildRef: useRef(null),
        priceRef: useRef(null),
        descriptionRef: useRef(null),
        sponsorRef: useRef(null),
        featuresRef: useRef(null),
        PartnerBoxCommercialRef: useRef(null),
        locationDescriptionRef: useRef(null),
        additionalDescriptionRef: useRef(null),
        energyRef: useRef(null),
        sellerLeadTeaserRef: useRef(null),
        richMediasRef: useRef(null),
        documentsRef: useRef(null),
        priceComparisonRef: useRef(null),
        PartnerBoxServicesRef: useRef(null),
        classifiedKeysRef: useRef(null),
        mobilePreview: {
            ref: mobilePreviewRef,
            inView: inViewMobilePreview,
        },
        geoRisksRef: useRef(null),
    };
    return _jsx(RefsContext.Provider, { value: refs, children: children });
};
